/* eslint-disable */

import React from "react";
import { render } from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { store, persistor } from "./store";
import App from "./layouts/App";
import axios from "axios";
import { PersistGate } from "redux-persist/integration/react";

axios.defaults.headers.common["blId"] = sessionStorage.getItem("blId");

render(
  <BrowserRouter>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
  </BrowserRouter>,
  document.getElementById("root")
);

if (module.hot) {
  module.hot.accept();
}
